import {request} from '@/helpers/apiClient';
import {PERFECT_STORE_CONFIG} from '@/utils/constants/apiConfig/perfectStoreConfig';

export const getPerfectStoreList = (queryParams = '', body = {}) =>
  request(PERFECT_STORE_CONFIG.PERFECT_STORE_LIST(queryParams), {data: body});

export const getPerfectStoreDetail = (id) =>
  request(PERFECT_STORE_CONFIG.GET_PERFECT_STORE_DETAIL(id), '');

export const addDraftPerfectStore = (reqObj) =>
  request(PERFECT_STORE_CONFIG.ADD_DRAFT_PERFECT_STORE, reqObj, '');

export const updateDraftPerfectStore = (reqObj) =>
  request(PERFECT_STORE_CONFIG.UPDATE_DRAFT_PERFECT_STORE, reqObj, '');

export const publishPerfectStore = (reqObj) =>
  request(PERFECT_STORE_CONFIG.PUBLISH_PERFECT_STORE, reqObj, '');

export const updatePerfectStore = (reqObj) =>
  request(PERFECT_STORE_CONFIG.UPDATE_PERFECT_STORE, reqObj, '');

export const validatePerfectStoreName = (queryParams) =>
  request(PERFECT_STORE_CONFIG.VALIDATE_PERFECT_STORE_NAME, '', queryParams);

export const importFirstPositionTargetFile = (id, reqObj) =>
  request(PERFECT_STORE_CONFIG.IMPORT_FIRST_POSITION_TARGET_FILE(id), {
    data: reqObj
  });

export const getVisitStatusTemplate = (targetId) =>
  request(PERFECT_STORE_CONFIG.GET_VISIT_STATUS_TEMPLATE(targetId), '');

export const updateStoreVisitsTemplate = (targetId, reqObj) =>
  request(PERFECT_STORE_CONFIG.UPDATE_STORE_VISITS_TEMPLATE(targetId), {
    data: reqObj
  });

export const getVisitList = (targetId, queryParams, filters = []) =>
  request(PERFECT_STORE_CONFIG.GET_VISIT_LIST(targetId, queryParams), {
    data: filters
  });

export const getPerfectStoreReportDownload = (targetId) =>
  request(PERFECT_STORE_CONFIG.DOWNLOAD_PERFECT_STORE_REPORT(targetId));

export const getPerfectStoreCsvFile = (queryParams, body) =>
  request(PERFECT_STORE_CONFIG.PERFECT_STORE_DOWNLOAD(queryParams), {
    data: body
  });
